module.exports = __webpack_public_path__ + "4e2454ee.svg";